import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import JsonBlockGenerator from '../components/JsonBlockGenerator';

export default class TourismPrimaryDialog extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <JsonBlockGenerator filename={'tourism_primary.json'} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
